import type { Pagination, PourFormat } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'core/pour-formats';

export function getPourFormats(query: PourFormat.SearchQuery) {
    return api.get<Pagination<PourFormat.DetailsResponse>>(
        `${rootPath}`,
        query
    );
}

export function getPourFormat(id: number) {
    return api.get<PourFormat.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postPourFormat(data: PourFormat.CreateRequest) {
    return api.post<PourFormat>(`${rootPath}`, data);
}

export function putPourFormat(id: number, data: PourFormat.UpdateRequest) {
    return api.put<PourFormat>(`${rootPath}/${id}`, data);
}

export function deletePourFormat({ id }: PourFormat.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
